/* eslint react/no-array-index-key: off */
import React from 'react';
import PropTypes from 'prop-types';
import { v as bvVar } from 'bv';

const currentLocale = bvVar('locale');

const ratingStars = (rating) => [0, 1, 2, 3, 4].map((star) => {
  if (rating > star + 0.6) return 'full-star';
  if (rating > star) return 'half-star';
  return 'empty-star';
});

const Rating = ({ rating, number_of_reviews: numberOfReviews }) => (
  <div className="smartbanner-stars">
    { ratingStars(rating).map((starClass, index) => <div key={`smartbanner-star-${index}`} className={`star ${starClass}`} />) }
    {
      numberOfReviews
      && <span className="reviews">{numberOfReviews.toLocaleString(currentLocale)}</span>
    }
  </div>
);

Rating.propTypes = {
  rating: PropTypes.number.isRequired,
  number_of_reviews: PropTypes.number.isRequired,
};

export default Rating;
